import { render } from "./MenuAdmin.vue?vue&type=template&id=77eb2aa6&scoped=true"
import script from "./MenuAdmin.vue?vue&type=script&lang=js"
export * from "./MenuAdmin.vue?vue&type=script&lang=js"

import "./MenuAdmin.vue?vue&type=style&index=0&id=77eb2aa6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77eb2aa6"]])

export default __exports__